<template>
  <div class="en-file">
    <div
      class="show-content"
      :class="{'no-data': !fileName,'is-disabled': disabled}"
    >
      {{ fileName ? fileName : "请选择" }}
    </div>
    <input type="file" :disabled="disabled || fullData.disabled" @change="selectImg($event)"
           accept="image/png,image/jpeg">
    <en-tips
      v-model="showTips"
      :tips="message"
    >
    </en-tips>
  </div>
</template>

<script>
import enTips from "./../en-tips";

export default {
  name: "index",
  components: {enTips},
  props: {
    value: {
      default: {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fullData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      fileName: "",
      showTips: false,
      message: ""
    };
  },
  computed: {
    uploadInfo() {
      return JSON.parse(localStorage.getItem("uploadInfo"));
    }
  },
  mounted() {
    this.fullData._setValue = (nVal) => {
      this.setValue(nVal);
    }
  },
  created() {
    if (this.fullData.mdValue) {
      this.setValue(this.fullData.mdValue);
    }
  },
  watch: {
    value: {
      deep: true,
      handler(nVal) {
        this.setValue(nVal)
      }
    }
  },
  methods: {
    setValue(nVal) {
      this.fileName = nVal[0].fileName
    },
    /**
     * @description 选择完照片后，进行接口请求
     * @param e
     * @return {Promise<void>}
     */
    async selectImg(e) {
      let result = await this.$api.post(this.uploadInfo.server, {
        appKey: this.uploadInfo.appKey,
        token: this.uploadInfo.token,
        ts: this.uploadInfo.ts,
        storage_file: e.target.files[0]
      });
      // 提交成功后，进行数据重整，拼接后返回
      if (result.isSuccess) {
        this.fileName = e.target.files[0].name;
        const nVal = [{
          type: "000",
          angle: "",
          fileCode: result.data.fileCode,
          code: result.data.fileCode,
          extension: e.target.files[0].type.split("/")[1],
          size: e.target.files[0].size,
          fileName: this.fileName
        }]
        this.$emit("input", nVal);
        this.setValue(nVal)
        this.$emit("change", this.fullData);
      } else {
        this.showTips = true;
        this.message = result.msg;
        this.fileName = "";
      }
    }
  }
};
</script>

<style lang="scss">
  .en-file {
    position: relative;

    input {
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 3;
      position: relative;
    }

    .show-content {
      width: 100%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: 2;
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
</style>
